import { type DocumentNode, gql } from '@apollo/client';

const deleteFieldMapsMutation: DocumentNode = gql`
  mutation delete_field_map($fieldMapId: ID!) {
    deleteFieldMap(fieldMapId: $fieldMapId) {
      fieldMap {
        id
        externalFieldId
      }
    }
  }
`;

export default deleteFieldMapsMutation;
